import React, { useEffect, useState } from "react";
// import Modal from "react-modal";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./PopUpModal.css";
import "../../common/Allcommon.css";
import "./login.css";
import { baseUrl } from "../../../enum/constant";

const LoginModal = ({
  isOpen,
  onRequestClose,
  setAuth,
  setRole,
  setUserName,
  setUserEmail,
  onForgotPassword,
  onSignupClick,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const toggleShow = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitDisabled(true);
    setError("");
    setSuccess("");

    try {
      const base = baseUrl;
      const response = await axios.post(base + "api/login", {
        email,
        password,
      });

      const { token, user } = response.data;

      // Set the token and role in state
      setAuth(token);
      setRole(user.role);
      setUserName(user.name);
      setUserEmail(user.email);
      navigate("/dashboard");
      // Store token and role in localStorage
      localStorage.setItem("userName", user.name);
      localStorage.setItem("email", user.email);
      localStorage.setItem("token", token);
      localStorage.setItem("role", user.role);
      localStorage.setItem("userId", user.id); // Store the logged-in user's ID

      // Show success message
      setSuccess("Logged in successfully!");

      // Clear the input fields
      setEmail("");
      setPassword("");
      navigate("/dashboard");

      // Delay navigation to allow the success message to be visible
      setTimeout(() => {
        setSubmitDisabled(false);
        navigate("/dashboard");

        setSuccess(""); // Clear success message after a delay
        // navigate("home"); // Navigate to dashboard
        onRequestClose(); // Close the modal
      }, 2000); // Adjust the timeout as needed
    } catch (error) {
      setError("Invalid email or password. Please try again.");
      console.error("Login failed", error);
      setSubmitDisabled(false);
      // Clear the error message after a delay
      setTimeout(() => {
        setError("");
      }, 3000); // Error message will disappear after 3 seconds
    }
  };

  useEffect(() => {
    setEmail("");
    setPassword("");
    setShowPassword(false);

    return () => {
      setEmail("");
      setPassword("");
      setShowPassword(false);
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="pop-main" onClick={onRequestClose}>
        <div className="pop-wrap" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <button
                type="button"
                onClick={onRequestClose}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Sign in to your account
                </h5>
              </div>
              {error && (
                <div className="alert alert-danger text-center mt-3">
                  {error}
                </div>
              )}
              {success && (
                <div className="alert alert-success text-center mt-3">
                  {success}
                </div>
              )}
              <div className="modal-body">
                <div className="fm-outer">
                  <label>Email</label>
                  <input
                    className="fm-cont"
                    type="text"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {/* <div className="error">
                      <span>Validation will sow here developr will update this and hide this.</span>
                    </div> */}
                </div>
                <div className="fm-outer pass-view cus-pass-div">
                  <label>Password</label>
                  <input
                    className="fm-cont"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  {showPassword ? (
                    <div className="eye-div" onClick={toggleShow}>
                      <img
                        className="eye-slash"
                        src="images/new/eye-slash.png"
                      />
                    </div>
                  ) : (
                    <div className="eye-div" onClick={toggleShow}>
                      <img className="eye" src="images/new/eye.png" />
                    </div>
                  )}
                </div>
                <div className="fom-row text-right">
                  <Link to="#" className="forgot" onClick={onForgotPassword}>
                    Forgot Password?
                  </Link>
                </div>
                <div className="button-group">
                  <button
                    type="submit"
                    disabled={submitDisabled || (!email && !password)}
                    className={`btn ${
                      submitDisabled || (email && password)
                        ? "blue-btn"
                        : "grey-btn"
                    } `}
                  >
                    {submitDisabled ? "Signing in..." : "Sign In"}
                  </button>
                </div>
                <div className="mt-3 new-t text-center">
                  <p>
                    New to Kittrow Investments s.r.o.?{" "}
                    <Link to="#" className="forgot" onClick={onSignupClick}>
                      Sign Up
                    </Link>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginModal;
